export default __webpack_public_path__ + "static/media/logo_branco.7ac7d6a3.png";